














import { Component, Prop, Vue } from 'vue-property-decorator'
import Route, { nextPage, prevPage } from '@/routes'
import progressBar from '@/components/progressBar.vue'
import { Getter, Action } from 'vuex-class'

@Component({
  components: { progressBar }
})
export default class Footer extends Vue {
  @Prop() private msg!: string
  @Getter private endReached!: boolean
  @Action resetEverything!: () => Promise<void>

  async reset() {
    if (!confirm('Are you sure you want to reset all of your data?')) {
      return
    }
    await this.resetEverything()
  }

  shouldShowResetLink () {
    return this.$router.currentRoute.name === Route.results
  }

  shouldShowPrevPage () {
    if (this.$router.currentRoute.name === Route.email) {
      return true
    }
    if (this.endReached) {
      return false
    }
    if (!this.prevPage()) {
      return false
    }
    return true
  }

  prevPage () {
    return prevPage(this.$router.currentRoute.name as Route)
  }

  nextPage () {
    const route = this.$router.currentRoute.name as Route
    if (this.endReached) {
      switch (route) {
      case Route.step1:
      case Route.step2:
      case Route.step3:
      case Route.step4:
      case Route.step5:
      case Route.step6:
      case Route.step7:
        return Route.results
      default:
      return nextPage(route)
      }
    }
    return nextPage(route)
  }

  label () {
    const route = this.$router.currentRoute.name
    if (route === Route.home) {
      return 'Let\'s Start'
    }
    if (route === Route.results) {
      return 'Email me my budget'
    }
    if (route === Route.email) {
      return 'Send me my report'
    }
    if (this.endReached) {
      return 'Update My Result'
    }
    if (route === Route.step7) {
      return 'See my results'
    }
    return 'Next Step'
  }

  nextButtonMessage () {
    if (this.endReached) {
      return ''
    }
    const route = this.$router.currentRoute.name
    if (route === Route.step1) {
      return 'Let’s look at some of the big-ticket spending items your household has'
    }
    if (route === Route.step2) {
      return 'Next up is day to day spending, childcare, groceries etc.'
    }
    if (route === Route.step3) {
      return 'Let’s look at those bits we spend on ourselves next.'
    }
    if (route === Route.step4) {
      return 'Next, let’s understand how much we spend on paying off personal debt.'
    }
    if (route === Route.step5) {
      return 'Coming near the end now – how you protect what you have is next up.'
    }
    if (route === Route.step6) {
      return 'Last page coming up, exploring how much you save.'
    }
    if (route === Route.step7) {
      return 'That’s it, you’re all done! Check out the result.'
    }
    return false
  }
}
